export default __webpack_public_path__ + "static/part1_1-91b06e3b45a4f1f09d871a0e017da836.png";